<template>
  <div style="padding:50px; margin:0 auto; text-align: center;">
    <h1>
      Loading
    </h1>
  </div>
</template>

<script>
export default {
  name: 'CoreCommonLoading'
};
</script>
